import { render, staticRenderFns } from "./preview-asset-gallery.vue?vue&type=template&id=0ac0e1cd&scoped=true&"
import script from "./preview-asset-gallery.vue?vue&type=script&lang=ts&"
export * from "./preview-asset-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./preview-asset-gallery.vue?vue&type=style&index=0&id=0ac0e1cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0e1cd",
  null
  
)

export default component.exports